import React, { useEffect, useRef, useState } from "react";
import { ArrowUp } from "lucide-react";

export function BackToTop() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 400);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  const toTop = () => window.scrollTo({ top: 0, behavior: "smooth" });
  return (
    <button
      onClick={toTop}
      aria-label="Torna in cima"
      data-testid="back-to-top"
      className={`fixed bottom-6 right-6 z-50 w-12 h-12 rounded-full bg-[#FF7A29] text-white shadow-xl shadow-orange-500/40 flex items-center justify-center hover:bg-[#E85D00] btn-glow transition-all duration-300 ${show ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4 pointer-events-none"}`}
    >
      <ArrowUp className="w-5 h-5"/>
    </button>
  );
}

/** Counter that animates from 0 to `end` when visible. Supports decimal values. */
export function Counter({ end, duration = 1400, prefix = "", suffix = "", decimals = 0, className = "" }) {
  const [val, setVal] = useState(0);
  const ref = useRef(null);
  const startedRef = useRef(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting && !startedRef.current) {
          startedRef.current = true;
          const startTime = performance.now();
          const animate = (now) => {
            const t = Math.min(1, (now - startTime) / duration);
            // easeOutCubic
            const eased = 1 - Math.pow(1 - t, 3);
            setVal(end * eased);
            if (t < 1) requestAnimationFrame(animate);
            else setVal(end);
          };
          requestAnimationFrame(animate);
        }
      });
    }, { threshold: 0.35 });
    obs.observe(el);
    return () => obs.disconnect();
  }, [end, duration]);

  const formatted = decimals > 0
    ? val.toFixed(decimals).replace(".", ",")
    : Math.round(val).toString();

  return <span ref={ref} className={className}>{prefix}{formatted}{suffix}</span>;
}
